import { type UseQueryResult, useQuery } from 'react-query';
import { BrokerSsoConfigurationKeyService } from '../../services/wealthlane-identity-services/services/BrokerSsoConfigurationKeyService';
import { PagedResultDto_BrokerSsoConfigurationKeyDto } from '../../services/wealthlane-identity-services/models/PagedResultDto_BrokerSsoConfigurationKeyDto';

const useGetBrokerSsoKeyManagementList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  //   tableInfo: TableParamsType,
  id: string
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_BrokerSsoConfigurationKeyDto | undefined,
  unknown
> => {
  const brokerSsoKeyManagementList = useQuery(['getBrokerSsoKeyManagementList', id], async () => {
    if (id) {
      return await handleRequest(
        BrokerSsoConfigurationKeyService.getApiIdentityApiAppBrokerSsoConfigurationKeyByConfigurationId(
          id
        )
      );
    }
  });
  return brokerSsoKeyManagementList;
};

export default useGetBrokerSsoKeyManagementList;
